<template>
  <div>
    <div class="page-header clear-filter" filter-color="">
      <parallax
        class="page-header-image"
        style="background-image:url('img/weld2.png')"
      >
      </parallax>
      <div class="container">
        <h3 class="title mt-5">{{ $t('service.pageTitle') }}</h3>
      </div>
    </div>
    <div class="section">
      <div class="container">

      <h3 class="mb-4 font-weight-bold">
        <img
          src="img/icon/icon (7).png" alt=""
          width="4%"
          class="ml-3 mr-3"
        /> <span style="color: #008c45;">{{ $t('service.pageTitle') }}</span>
      </h3>

        <div class="card-custom card-body">
          <!-- Content goes here -->
          <h3>{{ $t('service.expertise.title') }}</h3>
          <h5 v-html="$t('service.expertise.description')"></h5>
        </div>

      </div>

      <!-- <div class="container">
        <div class="row mt-5">
          <div class="col-md-10 col-xl-6 text-left">
            <h3 class="font-weight-bold text-left align-middle">
               <span style="color: green;">[Vision]</span>
            </h3>
            <span class="text-left mt-n3">
              We bring together Mastery Meets Innovation to solve corrosion issues and other process industry problems in one place. We aim to become a trusted, one-stop leading fabricator that gives everyone peace of mind.
            </span>

            <h3 class="font-weight-bold text-left align-middle mt-5">
               <span style="color: green;">[Mission]</span>
            </h3>
            <span class="text-left mt-n3">
              We build strong trust and create new possibilities in the process industry with mastery, innovation, a passion for challenges, and honesty. 
              We combine craftsmanship with advanced technology to provide high-quality products and services. <br>
              Our goal is to ensure stable operations and peace of mind for our customers while continuously bringing new value to their businesses. 
              We embrace challenges and drive change with passion. By doing so, we shape an exciting future that inspires the process industry and leads to continuous 
            </span>
          </div>
          <div class="col-md-10 col-xl-6 text-left align-middle mt-4">
            <img
              src="img/organization_chart.png"
              class="rounded animated fadeInDown"
            />
          </div>
        </div>
      </div> -->

      <div class="section section-tabs mt-5">
        <div class="container">

          <h3 class="mb-4 font-weight-bold">
            <img
              src="img/icon/icon (7).png" alt=""
              width="5%"
              class="ml-3 mr-3"
            /> <span style="color: #008c45;">{{ $t('service.fabricationSolutions.heading') }}</span>
          </h3>
          <h5>{{ $t('service.fabricationSolutions.intro') }}</h5>
          <div class="row align-items-stretch">
              <div class="col-lg-3 mb-4 d-flex">
                <router-link to="/detail-product-vessel" class="fab-card-link w-100">
                  <div class="card text-dark fab-card">
                    <div class="icon-circle mb-4">
                      <img
                        src="img/icon/icon (8).png" alt=""
                        width="60%"
                        class="ml-3 mr-3"
                      />
                    </div>
                    <h5>{{ $t('service.fabricationSolutions.cards.vessels.title') }}</h5>
                    <p class="fab-card-desc">{{ $t('service.fabricationSolutions.cards.vessels.desc') }}</p>
                  </div>
                </router-link>
              </div>
            <div class="col-lg-3 mb-4 d-flex">
              <router-link to="/detail-product-piping" class="fab-card-link w-100">
                <div class="card text-dark fab-card">
                  <div class="icon-circle mb-4">
                    <img
                      src="img/icon/icon (9).png" alt=""
                      width="60%"
                      class="ml-3 mr-3"
                    />
                  </div>
                  <h5>{{ $t('service.fabricationSolutions.cards.piping.title') }}</h5>
                  <p class="fab-card-desc">{{ $t('service.fabricationSolutions.cards.piping.desc') }}</p>
                </div>
              </router-link>
            </div>
            <div class="col-lg-3 mb-4 d-flex">
              <router-link to="/detail-product-mufle" class="fab-card-link w-100">
                <div class="card text-dark fab-card">
                  <div class="icon-circle mb-4">
                    <img
                      src="img/icon/icon (10).png" alt=""
                      width="60%"
                      class="ml-3 mr-3"
                    />
                  </div>
                  <h5>{{ $t('service.fabricationSolutions.cards.heating.title') }}</h5>
                  <p class="fab-card-desc">{{ $t('service.fabricationSolutions.cards.heating.desc') }}</p>
                </div>
              </router-link>
            </div>
            <div class="col-lg-3 mb-4 d-flex">
              <router-link to="/detail-product-other" class="fab-card-link w-100">
                <div class="card text-dark fab-card">
                  <div class="icon-circle mb-4">
                    <img
                      src="img/icon/icon (11).png" alt=""
                      width="60%"
                      class="ml-3 mr-3"
                    />
                  </div>
                  <h5>{{ $t('service.fabricationSolutions.cards.etc.title') }}</h5>
                  <p class="fab-card-desc">{{ $t('service.fabricationSolutions.cards.etc.desc') }}</p>
                </div>
              </router-link>
            </div>

            <h3 class="mb-4 font-weight-bold mt-4">
              <img
                src="img/icon/icon (12).png" alt=""
                width="6%"
                class="ml-3 mr-3"
              /> <span style="color: #008c45;">{{ $t('service.maintenance.heading') }}</span>
            </h3>
            <h5>
              {{ $t('service.maintenance.description') }}
            </h5>
          </div>

          <div class="maintenance-grid">
            <router-link to="/detail-service-retubing" class="maintenance-btn"><i class="fas fa-certificate"></i> {{ $t('service.maintenance.buttons.retubing') }}</router-link>
            <router-link to="/detail-service-piping" class="maintenance-btn"><i class="fas fa-certificate"></i> {{ $t('service.maintenance.buttons.pipelineRepairs') }}</router-link>
            <router-link to="/detail-product-service" class="maintenance-btn"><i class="fas fa-certificate"></i> {{ $t('service.maintenance.buttons.onSiteMaintenance') }}</router-link>
            <router-link to="/detail-service-shell" class="maintenance-btn"><i class="fas fa-certificate"></i> {{ $t('service.maintenance.buttons.etc') }}</router-link>
          </div>

          

        <!-- <div class="row mt-n4">
          <div class="col-md-10 col-xl-6 text-left">
            <h3 class="font-weight-bold text-left align-middle">
               <span style="color: green;">[Vision]</span>
            </h3>
            <span class="text-left mt-n3">
              We bring together Mastery Meets Innovation to solve corrosion issues and other process industry problems in one place. <br>
              We aim to become a trusted, one-stop leading fabricator that gives everyone peace of mind.
            </span>

            <h3 class="font-weight-bold text-left align-middle mt-5">
               <span style="color: green;">[Mission]</span>
            </h3>
            <span class="text-left mt-n3">
              We build strong trust and create new possibilities in the process industry with mastery, innovation, a passion for challenges, and honesty. 
              We combine craftsmanship with advanced technology to provide high-quality products and services. <br>
              Our goal is to ensure stable operations and peace of mind for our customers while continuously bringing new value to their businesses. <br>
              We embrace challenges and drive change with passion. <br>
              By doing so, we shape an exciting future that inspires the process industry and leads to continuous growth and innovation. <br>
              This is the mission of TEF.
            </span>
          </div>
          <div class="col-md-10 col-xl-6 text-left align-middle mt-4">
            <img
              src="img/new_organization.png"
              class="rounded animated fadeInDown"
            />
          </div>
        </div> -->
      </div>
      </div>
      </div>

      <!-- <marquee style="margin-top: -70px; margin-bottom: -20px;">
        <div style="white-space: nowrap;">
          <img width="20%" src="img/footer_welding.jpg" />
          <img width="20%" src="img/prod.jpeg" />
          <img width="19%" src="img/vessel1.png" />
          <img width="20%" src="img/facility/crane.jpg" />
          <img width="20%" src="img/facility/machine_hydraulic.jpg" />
          <img width="20%" src="img/facility/gatot_kaca.jpg" />
          <img width="20%" src="img/facility/machine_hydraulic.jpg" />
        </div>
      </marquee> -->

      <div class="marquee-container" style="margin-top: -70px; margin-bottom: -20px;">
        <div class="marquee-track">
          <div class="marquee-group">
            <img src="img/footer_welding.jpg" alt="" />
            <img src="img/prod.jpeg" alt="" />
            <img src="img/vessel1.png" alt="" />
            <img src="img/facility/crane.jpg" alt="" />
            <img src="img/facility/gatot_kaca.jpg" alt="" />
            <img src="img/detail_product/service/Retubing/03_Cleaning Tube.jpeg" alt="" />
            <img src="img/he_service.png" alt="" />
            <img src="img/detail_product/service/Piping/05_Support Installation.jpeg" alt="" />
          </div>
          <div class="marquee-group">
            <!-- <img src="img/prod.jpeg" /> -->
            <!-- <img width="19%" src="img/vessel1.png" />
            <img src="img/facility/crane.jpg" />
            <img src="img/facility/machine_hydraulic.jpg" />
            <img src="img/facility/gatot_kaca.jpg" />
            <img src="img/facility/machine_hydraulic.jpg" /> -->
          </div>
        </div>
      </div>
    
    <!-- <div class="section section-tabs text-center">
      <div class="container">
        <h2 class="title">Our Team</h2>
        <h4>We are a team of creatives people innovation</h4>
        <div class="team">
          <div class="row mt-5">
            <div class="col-md-3">
              <div class="team-player">
                <img
                  src="img/default-avatar.png"
                  alt="Thumbnail Image"
                  class="rounded-circle img-fluid img-raised"
                />
                <h4 class="title">Mamad Saepulloh</h4>
                <p class="category text-success">Production</p>
              </div>
            </div>
            <div class="col-md-3">
              <div class="team-player">
                <img
                  src="img/default-avatar.png"
                  alt="Thumbnail Image"
                  class="rounded-circle img-fluid img-raised"
                />
                <h4 class="title">Qodratulloh</h4>
                <p class="category text-success">Engineering/Design</p>
              </div>
            </div>
            <div class="col-md-3">
              <div class="team-player">
                <img
                  src="img/fitri.jpeg"
                  alt="Thumbnail Image"
                  class="rounded-circle img-fluid img-raised"
                />
                <h4 class="title">Fitri Hayati</h4>
                <p class="category text-success">Cost Control</p>
              </div>
            </div>
            <div class="col-md-3">
              <div class="team-player">
                <img
                  src="img/default-avatar.png"
                  alt="Thumbnail Image"
                  class="rounded-circle img-fluid img-raised"
                />
                <h4 class="title">Subandi</h4>
                <p class="category text-success">Project Control</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div> -->

    <!-- MOTO TOKKI  -->
    <div class="page-header clear-filter moto-office-section" filter-color="purple">
      <div class="parallax">
        <div class="container" style="">
          <h1 class="text-white text-left pt-5 font-weight-bold text-center">START <span style="font-size: 20px; color: yellow;"> {{ $t('common.offices.motoStartWithTokki') }} </span></h1>
          <div class="row pt-5 mt-n4">
            <div class="col-lg-3 text-left">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.mainOfficeFactory') }}  :</span></h6>
              Kawasan Industri Jababeka 1
              Jl.Jababeka XIIB Blok W26
              Cikarang-Bekasi, Jawa Barat Indonesia Kode Pos 17530
              Telp: +62-21 893 6733 (Hunting) <br><br>

              Phone : +62 - 21 8936733 (Hunting)<br>
              Fax   : +62 - 21 8936738<br>
              Email : sales@tef.co.id<br>
            </div>
            <div class="col-lg-3 text-left">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.secondOfficeFactory') }}</span></h6>
              Kawasan Industri Krakatau 1,
              Jl. Australia I Kav. C1/2, Kel. Warnasari, Kec. Citangkil
              Kota Cilegon, Banten - Indonesia 42443 <br><br>

              Phone : +62 - 254 8317244<br>
              Fax   : +62 - 254 8317244<br>
              Email : sales02@tef.co.id<br>
            </div>
            <div class="col-lg-3 text-left">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.thirdOfficeFactory') }}</span></h6>
              Pergudangan AKR GEM City F-09, Kabupaten Gresik, Jawa Timur <br><br><br>

              Phone : +62 - 31 39935914<br>
              Fax   : +62 - 31 39935914<br>
              Email : sales02@tef.co.id<br>
            </div>
            <div class="col-lg-3 text-left mb-5">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.fourthMarketingOffice') }}</span></h6>
              Jl. Gn. Leuser, Tj. Marulak, Kec. Rambutan, Kota Tebing Tinggi, Sumatera Utara 20998 <br><br><br>

              Phone : +62 811-1972-2507<br>
              Email : sales@tef.co.id<br>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
// import { Tabs, TabPane } from '@/components';

export default {
  name: 'profile',
  bodyClass: 'profile-page',
  components: {
    // Tabs,
    // TabPane
  }
};
</script>
<style scoped>
   .animated {
     
      padding-top:0px;
      margin-bottom:0px;
      -webkit-animation-duration: 5s;
      animation-duration: 5s;
      -webkit-animation-fill-mode: both;
      animation-fill-mode: both;
   }
   
   @-webkit-keyframes fadeInDown {
      0% {
         opacity: 0;
         -webkit-transform: translateY(-20px);
      }
      100% {
         opacity: 1;
         -webkit-transform: translateY(0);
      }
   }
   
   @keyframes fadeInDown {
      0% {
         opacity: 0;
         transform: translateY(-50px);
      }
      100% {
         opacity: 1;
         transform: translateY(0);
      }
   }
   
   .fadeInDown {
      -webkit-animation-name: fadeInDown;
      animation-name: fadeInDown;
   }
</style>

 <style scoped>
    body {
      background-color: #f2f2f2;
    }

    .card-custom {
      background-color: #008c45;
      color: white;
      border-radius: 20px;
      padding: 32px;
      box-shadow: 0 10px 26px rgba(0, 0, 0, 0.15);
    }

    .collapse-btn {
      background-color: #00994d;
      color: white;
      font-weight: bold;
      border-radius: 30px;
      margin-top: 15px;
      padding: 10px 20px;
      text-align: left;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .collapse-btn:focus {
      outline: none;
      box-shadow: none;
    }

    .collapse-btn:hover {
      background-color: #007f3f;
      color: white;
    }

    .collapse-content {
      margin-top: 10px;
    }

    .icon-section {
      margin-right: 10px;
    }

    .collapse-toggle-icon {
      font-size: 1.5rem;
    }
  </style>

  <!-- vission mission -->
  <style scoped>
    body {
      font-family: Arial, sans-serif;
      background-color: #e0e0e0;
    }

    h2 {
      color: #007a3d;
      display: flex;
      align-items: center;
      font-size: 1.8rem;
    }

    h2 i {
      margin-right: 10px;
      font-size: 1.8rem;
    }

    .card {
      background-color: white;
      border-radius: 25px; /* Rounded lebih besar */
      box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
      padding: 25px;
      margin-top: 20px;
    }

    .card-header {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }

    .icon-circle {
      width: 55px;
      height: 55px;
      border-radius: 50%;
      background-color: #d58e24;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 15px;
      flex-shrink: 0;
    }

    .icon-circle i {
      color: white;
      font-size: 22px;
    }

    .card-header h3 {
      margin: 0;
      font-size: 1.5rem;
      font-weight: bold;
    }

    .card-content ul {
      padding-left: 1rem;
      margin-top: 10px;
      font-size: 15px;
    }

    .card-content ul li {
      margin-bottom: 10px;
    }
  </style>

  <style scoped>
    .fab-card-link {
      text-decoration: none;
      width: 100%;
    }

    .fab-card {
      height: 100%;
      display: flex;
      flex-direction: column;
      transition: transform 0.3s ease, box-shadow 0.3s ease;
    }

    .fab-card-link:hover {
      text-decoration: none;
    }

    .fab-card:hover {
      transform: translateY(-8px);
      box-shadow: 0 16px 32px rgba(0, 0, 0, 0.15);
    }

    .fab-card:hover .icon-circle {
      background-color: #008c45;
      transform: scale(1.08);
      transition: transform 0.3s ease, background-color 0.3s ease;
    }

    .icon-circle {
      transition: transform 0.3s ease, background-color 0.3s ease;
    }

    .fab-card-desc {
      color: #6c757d;
      font-size: 14px;
      flex: 1;
    }

    .maintenance-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
      gap: 16px;
      margin-top: 20px;
    }

    .maintenance-btn {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 16px 20px;
      border-radius: 14px;
      border: 2px solid #008c45;
      color: #008c45;
      font-weight: 700;
      text-decoration: none;
      transition: all 0.3s ease;
    }

    .maintenance-btn i {
      font-size: 18px;
    }

    .maintenance-btn:hover {
      background-color: #008c45;
      color: #fff;
      text-decoration: none;
      transform: translateY(-4px);
      box-shadow: 0 10px 22px rgba(0, 140, 69, 0.3);
    }
  </style>

  <style>
    body {
      margin: 0;
      padding: 0;
      background: #f0f0f0;
    }

    .marquee-container {
      width: 100%;
      overflow: hidden;
      background: white;
    }

    .marquee-track {
      display: flex;
      animation: marquee 30s linear infinite;
    }

    .marquee-track .marquee-group {
      display: flex;
    }

    .marquee-track img {
      height: 250px;
      width: auto;
      object-fit: cover;
    }

    @keyframes marquee {
      0% {
        transform: translateX(0);
      }
      100% {
        transform: translateX(-50%);
      }
    }
  
.moto-office-section {
  max-height: none;
  height: auto;
  overflow: visible;
  padding-bottom: 40px;
}

.moto-office-section .parallax {
  height: auto;
  padding-bottom: 40px;
}
</style>
